// src/components/cruise-promotions-terms-and-conditions/cruise-promotions-terms-and-conditions.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSIconFragment on Icon {\n    id\n    description\n    theme\n    spotLight\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSIllustrationFragment on Illustration {\n    id\n    url\n    description\n    egdsElementId\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSMarkFragment on Mark {\n    id\n    markSize: size\n    markUrl: url {\n      ... on HttpURI {\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenityInfoFragment on CruiseAmenityInfo {\n    category\n    description\n    icon {\n      ...EGDSIconFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AmenitiesListFragment on CruiseAmenitiesList {\n    collapseLabel\n    collapseA11yLabel\n    expandLabel\n    expandA11yLabel\n    visibleItems\n    amenities {\n      ...AmenityInfoFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CruiseAmenityDetailsFragment on CruiseAmenityDetails {\n    title\n    amenitySummaries {\n      ...AmenitiesListFragment\n    }\n    amenitySummariesLabel\n    promotionText\n    benefitTexts\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  query CruisePromotionsQuery($context: ContextInput!, $cruiseRequestContextInput: CruiseRequestContextInput!, $promotionCodesInput: [String!]!) {\n    cruisePromotionsTermsAndConditionsDetails(\n      context: $context\n      cruiseRequestContextInput: $cruiseRequestContextInput\n      promotionCodesInput: $promotionCodesInput\n    ) {\n      termsAndConditions {\n        heading\n        amenities {\n          ...CruiseAmenityDetailsFragment\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import React8 from "react";
import { gql as gql8, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkCard } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// src/components/cruise-promotions-terms-and-conditions/__private/__fragments/cruise-amenity-details.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// ../internal/src/components/amenities-list/amenities-list.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkExpandoPeek } from "uitk-react-expando";
import { withUitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing } from "uitk-react-spacing";
// ../internal/src/components/amenities-list/__private/__fragments/amenity-info.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var _obj;
// ../internal/src/components/utils/spotlight-mapper.ts
var spotlightMapper = (_obj = {}, _defineProperty(_obj, "INFO" /* INFO */ , "info"), _defineProperty(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj, "WARNING" /* WARNING */ , "warning"), _defineProperty(_obj, "STANDARD" /* STANDARD */ , "standard"), _obj);
// ../internal/src/components/egds-graphic/egds-icon.tsx
var __EGDSIconFragment = gql(_templateObject());
var EGDSIcon = function(param) {
    var className = param.className, iconSize = param.iconSize, data = param.data;
    var id = data.id, description = data.description, theme = data.theme, spotLight = data.spotLight;
    var spotLightValue = spotLight ? spotlightMapper[spotLight] : void 0;
    return /* @__PURE__ */ React.createElement(UitkIcon, {
        className: className,
        id: id,
        name: id,
        title: description,
        description: description,
        size: iconSize || UitkIconSize.SMALL,
        theme: theme !== null && theme !== void 0 ? theme : void 0,
        spotlight: spotLightValue
    });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var __EGDSIllustrationFragment = gql2(_templateObject1());
var EGDSIllustration = function(param) {
    var className = param.className, data = param.data;
    var url = data.url, description = data.description;
    return /* @__PURE__ */ React2.createElement(UitkIllustrations, {
        url: url,
        alt: description,
        className: className
    });
};
EGDSIllustration.displayName = "EGDSIllustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkMark, UitkMarkTokenSizesList } from "uitk-react-mark";
var __EGDSMarkFragment = gql3(_templateObject2());
var EGDSMark = function(param) {
    var className = param.className, data = param.data;
    var id = data.id, markSize = data.markSize, markUrl = data.markUrl;
    var _ref;
    var size = (_ref = markSize && UitkMarkTokenSizesList[markSize]) !== null && _ref !== void 0 ? _ref : void 0;
    return /* @__PURE__ */ React3.createElement(UitkMark, {
        className: className,
        id: id,
        description: id,
        name: id,
        size: size,
        url: markUrl === null || markUrl === void 0 ? void 0 : markUrl.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
var __EGDSGraphicFragment = gql4(_templateObject3(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function(param) {
    var className = param.className, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React4.createElement(EGDSIcon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React4.createElement(EGDSMark, {
                className: className,
                data: data
            });
        case "Illustration":
            return /* @__PURE__ */ React4.createElement(EGDSIllustration, {
                className: className,
                data: data
            });
        default:
            return null;
    }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/amenities-list/__private/__fragments/amenity-info.tsx
var __AmenityInfoFragment = gql5(_templateObject4(), EGDSIcon.fragment);
var AmenityInfo = function(param) {
    var data = param.data;
    var category = data.category, description = data.description, icon = data.icon;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(EGDSIcon, {
        data: icon
    }), /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkText, {
        size: 300,
        weight: "bold"
    }, category), /* @__PURE__ */ React5.createElement(UitkText, {
        size: 300
    }, description)));
};
AmenityInfo.displayName = "AmenityInfo";
AmenityInfo.fragment = __AmenityInfoFragment;
// ../internal/src/components/amenities-list/amenities-list.tsx
var __AmenitiesListFragment = gql6(_templateObject5(), AmenityInfo.fragment);
var AmenitiesList = function(param) {
    var data = param.data, columns = param.columns, orientation = param.orientation;
    var collapseLabel = data.collapseLabel, collapseA11yLabel = data.collapseA11yLabel, expandLabel = data.expandLabel, expandA11yLabel = data.expandA11yLabel, visibleItems = data.visibleItems, amenities = data.amenities;
    var _React6_useState = _slicedToArray(React6.useState(false), 2), isVisible = _React6_useState[0], setIsVisible = _React6_useState[1];
    var toggleExpandoList = function() {
        setIsVisible(function(prevIsVisible) {
            return !prevIsVisible;
        });
    };
    if (collapseLabel && collapseA11yLabel && expandLabel && expandA11yLabel && visibleItems) {
        return /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(UitkExpandoPeek, {
            collapseLabel: collapseLabel,
            collapseA11yLabel: collapseA11yLabel,
            expandLabel: expandLabel,
            expandA11yLabel: expandA11yLabel,
            isVisible: isVisible,
            items: visibleItems,
            handleClick: toggleExpandoList,
            hideScrim: true
        }, /* @__PURE__ */ React6.createElement(UitkList, {
            spacing: false,
            bullet: "icon-alternate"
        }, amenities.map(function(amenity) {
            return /* @__PURE__ */ React6.createElement(UitkListItem, {
                key: amenity.description
            }, /* @__PURE__ */ React6.createElement(AmenityInfo, {
                data: amenity
            }));
        }))));
    }
    var AmenityList = function(listProps) {
        return /* @__PURE__ */ React6.createElement(UitkList, _objectSpread({
            spacing: false,
            bullet: "icon-alternate"
        }, listProps), amenities.map(function(amenity) {
            return /* @__PURE__ */ React6.createElement(UitkListItem, {
                key: amenity.description
            }, /* @__PURE__ */ React6.createElement(AmenityInfo, {
                data: amenity
            }));
        }));
    };
    if (orientation === "inline") {
        return /* @__PURE__ */ React6.createElement(UitkSpacing, {
            margin: {
                blockstart: "two"
            }
        }, /* @__PURE__ */ React6.createElement(AmenityList, {
            orientation: orientation
        }));
    }
    var AmenityListWithGrid = withUitkLayoutGrid(AmenityList);
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(AmenityListWithGrid, {
        columns: columns,
        space: "three"
    }));
};
AmenitiesList.displayName = "AmenitiesList";
AmenitiesList.fragment = __AmenitiesListFragment;
// src/components/cruise-promotions-terms-and-conditions/__private/__fragments/cruise-amenity-details.tsx
import { UitkList as UitkList2, UitkListItem as UitkListItem2 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText2 } from "uitk-react-text";
var __CruiseAmenityDetailsFragment = gql7(_templateObject6(), AmenitiesList.fragment);
var CruiseAmenityDetails = function(props) {
    var data = props.data;
    var title = data.title, amenitySummaries = data.amenitySummaries, amenitySummariesLabel = data.amenitySummariesLabel, promotionText = data.promotionText, benefitTexts = data.benefitTexts;
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(UitkSpacing2, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React7.createElement(UitkHeading, {
        tag: "h2",
        size: 5,
        align: "left"
    }, title)), /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkHeading, {
        className: "is-visually-hidden",
        tag: "h3"
    }, amenitySummariesLabel), amenitySummaries && /* @__PURE__ */ React7.createElement(AmenitiesList, {
        data: amenitySummaries,
        orientation: "inline"
    })), /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkSpacing2, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React7.createElement(UitkText2, {
        size: 300,
        align: "left"
    }, promotionText))), /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(UitkSpacing2, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React7.createElement(UitkList2, {
        spacing: false
    }, benefitTexts.map(function(message, index) {
        return /* @__PURE__ */ React7.createElement(UitkListItem2, {
            key: "terms-and-conditions-".concat(index)
        }, message);
    })))));
};
CruiseAmenityDetails.displayName = "CruiseAmenityDetails";
CruiseAmenityDetails.fragment = __CruiseAmenityDetailsFragment;
// src/components/cruise-promotions-terms-and-conditions/cruise-promotions-terms-and-conditions.tsx
var __CruisePromotionsQuery = gql8(_templateObject7(), CruiseAmenityDetails.fragment);
var CruisePromotionsTermsAndConditions = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__CruisePromotionsQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error;
    if (error || !data) {
        return null;
    }
    var termsAndConditions = data.cruisePromotionsTermsAndConditionsDetails.termsAndConditions;
    var heading = termsAndConditions.heading, amenities = termsAndConditions.amenities;
    return /* @__PURE__ */ React8.createElement(UitkSpacing3, {
        margin: "six"
    }, /* @__PURE__ */ React8.createElement(UitkCard, {
        padded: true
    }, /* @__PURE__ */ React8.createElement(UitkSpacing3, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkHeading2, {
        tag: "h1",
        size: 4,
        align: "left"
    }, heading)), /* @__PURE__ */ React8.createElement("div", null, amenities === null || amenities === void 0 ? void 0 : amenities.map(function(amenityDetails, index) {
        return /* @__PURE__ */ React8.createElement("div", {
            key: "amenity-details-".concat(index)
        }, /* @__PURE__ */ React8.createElement(CruiseAmenityDetails, {
            data: amenityDetails
        }));
    }))));
};
CruisePromotionsTermsAndConditions.displayName = "CruisePromotionsTermsAndConditions";
export { CruisePromotionsTermsAndConditions };
//# sourceMappingURL=index.js.map